import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "forgot-password" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("확인")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_Button = _resolveComponent("Button")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[2] || (_cache[2] = 
          () => {
            _ctx.alert.content = '';
          }
        )
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, { onSubmit: _ctx.forgetPassword }, {
        default: _withCtx(({ errors }) => [
          _createVNode("h2", null, _toDisplayString(_ctx.t("forgotPassword")), 1),
          _createVNode(_component_Field, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email = $event)),
            name: "email",
            rules: "required|email"
          }, {
            default: _withCtx(({ field }) => [
              _createVNode("div", null, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_InputText, _mergeProps({
                    id: "email",
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => (field.value = $event)
                  }, field, {
                    class: { 'p-invalid': errors.email },
                    placeholder: _ctx.l('forgotPassword'),
                    type: "text"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "class", "placeholder"])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["modelValue"]),
          _createVNode(_component_Button, {
            class: "-button -royalBlue",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}